const script_init = e => {
    // Custom sliders
    
    function isMobile() {
        let windowWidth = window.innerWidth;
        if(windowWidth < 769) {
            return true
        } else {
            return false;
        }
    }

    const debounce = (f, delay) => {
        let timer = 0;
        return function(...args) {
            clearTimeout(timer);
            timer = setTimeout(() => f.apply(this, args), delay);
        }
    }

    const sliderReinitCallback = ([entry]) => {
        const flkty = Flickity.data(entry.target);
        if (flkty) flkty.resize();
    }

    const initMobileOnlySlider = (slider, args) => {
        let flickity;

        function initSlider() {
            flickity = new theme.Slideshow(slider, args);
        }

        function unload() {
            if (flickity && typeof flickity.destroy === 'function') {
            flickity.destroy();
            }
        }

        if (isMobile()) {
            initSlider();
        }

        window.addEventListener('resize', function(event) {
            if(isMobile()) {
                initSlider();
            } else {
                unload();
            }
        }, true);
    }

    const initCustomSlider = (slider) => {
        let args = slider.dataset.args;
        const mobileOnly = slider.dataset.mobileOnly;
        if(args) {
            args = JSON.parse(args);
        }
        if(mobileOnly == "true") {
            initMobileOnlySlider(slider, args);
        } else {
            let flickity = new theme.Slideshow(slider, args);
            const reinitFlickitySlider = new ResizeObserver(debounce(sliderReinitCallback, 200));
            reinitFlickitySlider.observe(slider);
        }
    }

    const customSliders = document.querySelectorAll('.custom-slider-js');

    if(customSliders.length) {
        customSliders.forEach(slider => {
            initCustomSlider(slider);
        })
    }

    document.addEventListener('initDelayedSlider', () => {
        const delayedCustomSliders = document.querySelectorAll('.custom-slider-js--delayed');

        if(delayedCustomSliders.length) {
            delayedCustomSliders.forEach(slider => {
                initCustomSlider(slider);
            })
        }
    })

    // Filter endless scroll
    var endlessScroll = new Ajaxinate({
        method: 'scroll',
        loadingText: 'Loading more...',
    });
}

document.addEventListener('DOMContentLoaded', script_init, false);

document.addEventListener('click', function(event) {
    // Filter PLP
    const toggleSidebar = document.querySelector('.js-toggle-sidebar');
    const toggleSidebarProducts = document.querySelector('.toggle-sidebar_products');

    if (event.target.classList.contains('js-custom-open-collection-filters') ) {
        event.target.classList.toggle('active')
        toggleSidebar.classList.toggle('active')
    }

    // start ajax push pagination
    if ( event.target.classList.contains('js-btn-paginate') ) {
        window.history.pushState(window.location.host,"", event.target.getAttribute('href'));
    }

    // PLP view column
    if ( event.target.classList.contains('js-view-column') ) {
        event.target.classList.toggle('active');
        toggleSidebarProducts.classList.toggle('active-view');
    }
});

// Recommended Quick Add
$(document).on('click', '.recommended__quick-add-btn', (e) => {
    const btn = e.target;
    console.log({btn})
    if (!btn.classList.contains('recommended__quick-add-btn')) return;

    const var_id = btn.getAttribute('data-id');
    if (!var_id) return;

    const data = {
        "id": var_id,
        "quantity": 1
    }
    
    jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function() { 
            document.dispatchEvent(new CustomEvent('cart:build'));
            document.dispatchEvent(new CustomEvent('cart:open'));
        }
    });
})

const smoothScroll = document.querySelectorAll('.smooth-scroll');

smoothScroll.forEach(btn => {
    btn.addEventListener('click', () => {
        const target = document.querySelector(btn.dataset.selector);
        if (!target) return;
        target.scrollIntoView({behavior: "smooth"});
    })
})